import React, { useState,useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import {  api, WorkshopListURL, WorkshopPublicURL } from "../../../apis/urls";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RteEventComponent from "./TextEditor";
import RichTextEditor from "@mantine/rte";
import { DatePicker, message, Space, Spin } from "antd";
import moment from "moment";


const DatePickerGroup =({startDates, endDates, dateStart, dateEnd})=>{



    return(
        <div class="form-group">
        <div className="row">
            <div className="col-md-6">
                <label className="degreehead">Start Date<span style={{color: "red"}}>*</span></label>
                {startDates?
                <DatePicker
                className="workshop-date"
                showTime={{ format: 'HH:mm' }}
                format="MM-DD-YYYY HH:mm"
                defaultValue={moment( moment(startDates).format('MM-DD-YYYY HH:mm'), "MM-DD-YYYY HH:mm")} 
                style={{width:"100%"}} 
                onChange={(e)=>{dateStart(e)}} 
                />
                :null
                }
            </div>
            <div className="col-md-6">
                <label className="degreehead">End Date<span style={{color: "red"}}>*</span></label>
            {endDates?
                <DatePicker 
                className="workshop-date"
                format="MM-DD-YYYY HH:mm"
                defaultValue={moment( moment(endDates).format('MM-DD-YYYY HH:mm'), "MM-DD-YYYY HH:mm")} 
                style={{width:"100%"}} showTime 
                onChange={(e)=>{dateEnd(e)}} 
                />
                :null
            }
            </div>
        </div>
    </div>
    )

}

const WorkshopSessionUpdate = () => {

    const { wid, sid } = useParams();

    useEffect(() => {
        editlisting();
    },[]
    );

    const [res,setRes] = useState([]);
    const [name,setName] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [nameErr, setNameErr] = useState(false);


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/workshop/session/"+wid+"/"+sid)
        
    }


    const editlisting = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: WorkshopPublicURL+"workshop/session/view/"+sid,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            
            setRes(response.data.data);
            console.log(response.data.data.start_date)

            setName(response.data.data.name);
            setStartDate(response.data.data.start_date);
            setEndDate(response.data.data.end_date);
            }).catch((error) =>{
            
            console.log('error',error.message)
            

            });
    }

    const onEditForm = () => {


        let error = 0;

        

        if(error === 0) 
        {

            let token = "Bearer "+localStorage.getItem('token');
        
            const data = {
                name: name,
                start_date: startDate,
                end_date: endDate,
            }
            
            const instance = axios.create({

                baseURL: WorkshopPublicURL+"workshop/session/update/"+sid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.put('',data).then((response) =>{

                message.success('Session updated successfully')
                

                navigate("/sessions/"+wid)

            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });

        }

        
    }








    const startDatePick = (e) => {
        // console.log('Selected Time: ', moment(e).format('YYYY-MM-DD HH:mm'));
        setStartDate(moment(e).format('YYYY-MM-DD HH:mm'))
      };

      const endDatePick = (e) => {
        // console.log('Selected Time: ', moment(e).format('YYYY-MM-DD HH:mm'));
        setEndDate(moment(e).format('YYYY-MM-DD HH:mm'))
      };





    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Edit Session</h2>
                        </div>
                        <div className="page-rightside-action-column">
                           
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/workshop">Conference Manager</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/sessions/"+wid}>Sessions</Link></li>
                            
                            <li className="breadcrumb-item active" aria-current="page">Update Session</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                        <div className="form-wrpr">
                            <div class="card formcard medium">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label className="degreehead">Session Topic <span style={{color: "red"}}>*</span></label>
                                        <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setName(e.target.value)}} defaultValue={res.name} id="topic"></input>
                                        {
                                        nameErr
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Topic</div>
                                        :null
                                        }
                                    </div>


                                    <DatePickerGroup startDates={startDate} endDates={endDate} dateStart={startDatePick} dateEnd={endDatePick} />



                                    <h6 style={{color:"red", fontSize:'12px', paddingTop:'10px'}}>* Required Fields</h6>
                                    
                                    <div class="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button onClick={onEditForm} className="btn btn-primary btn-gisa" type="button">Update</button>
                                    </div>
                                    <div>
                                    {/* <button onClick={notify}>Notify !</button> */}
                                    <ToastContainer
                                        style={{width: 578, marginTop: '10%', marginLeft: '8.3%'}}
                                        toastStyle={{backgroundColor: "#f1c40f", color: 'white', fontSize: 16}}
                                        progressStyle={{backgroundColor: 'white'}}
                                        
                                    />
                                </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>


                </div>
            </aside>
        </div>
    )
}

export default WorkshopSessionUpdate;